
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {}

export default new Vuetify(opts, {
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#3562A8',
        secondary: '#213B66',
        accent: '#4985E6',
        info: '#4176CC'
      },
      dark: {
        primary: '#3562A8',
        secondary: '#213B66',
        accent: '#4985E6',
        info: '#4176CC'
      }
    }
  }
});